import axios from 'axios';
import store from '../store/index.js';
import router from '../router/index.js';
axios.defaults.timeout = 500000;
import vue from 'vue'
const pending = new Map()
import cancelToken from "./cancelToken.js"
axios.defaults.baseURL = process.env.VUE_APP_apiHost

axios.interceptors.request.use(function(config) {
	cancelToken.removePending(pending,config)
	cancelToken.addPending(pending,config)
	if(
	config.url!='https://account1.huashengchongwu.com/api/media/chufangjian_print'
	&&config.url!='https://account.huashengchongwu.com/api/media/upload_file'
	&&config.url!='https://account.huashengchongwu.com/api/media/upload_img'
	&&config.url!='https://account1.huashengchongwu.com/api/media/pos80_print'
	&&config.url!='https://account1.huashengchongwu.com/api/media/do_print'
	&&config.url!='https://account1.huashengchongwu.com/api/media/shop_print'
	&&config.url!='https://account.huashengchongwu.com/api/media/upload_video'
	){
		config.headers['Content-Type'] = 'application/json;';
		config.headers.platform = 'hs_o2o'; // platform
		config.headers.company_id = store.state.userInfo.companyId?store.state.userInfo.companyId:''; // 公司id
		config.headers.user_ip = store.state.ip; // ip地址
		config.headers.version = store.state.version;
	}
	config.headers.token = store.state.userInfo.token;
	return config;
}, function(error) {
	return Promise.reject(error);
});
axios.interceptors.response.use(function(response) {     
	cancelToken.removePending(pending,response)
	if (response.data) {
		if(response.data.code!=undefined){
			switch (response.data.code) {
				case -1:
					vue.prototype.$message({
						message: response.data.info,
						type: 'error'
					});
					break;
				case 0:
					return response;
				case 1:
					return response;
				case 400:
					vue.prototype.$message({
						message: response.data.info,
						type: 'error'
					});
					break;
				case 401:
					vue.prototype.$message({
						message: response.data.info,
						type: 'error'
					});
					router.push('/login');
					break;
				case 500:
					vue.prototype.$message({
						message: '网络异常，请联系技术部同事',
						type: 'error'
					});
					break;
				default:
					vue.prototype.$message({
						message: response.data.info,
						type: 'error'
					});
					break;
			}
		}else{
			return response;
		}
	}
	return response;
}, function(error) {
	return Promise.reject(error);
});
router.beforeEach((to, from, next) => {
	cancelToken.clearPending(pending)
	next()
})
export default {
	self:axios,
	get(url, params = {}) {
		return new Promise((resolve, reject) => {
			if(
			url!='https://account1.huashengchongwu.com/api/media/chufangjian_print'
			&&url!='https://account.huashengchongwu.com/api/media/upload_file'
			&&url!='https://account.huashengchongwu.com/api/media/upload_img'
			&&url!='https://account1.huashengchongwu.com/api/media/pos80_print'
			&&url!='https://account.huashengchongwu.com/api/media/upload_video'
			){
				axios.defaults.headers.shop_id = store.state.shopId;
			}else{
				delete axios.defaults.headers.shop_id
			}
			axios.get(url, {
				params
			}).then(response => {
				let data;
				data = response.data
				resolve(data);
			}).catch(err => {
				reject(err)
			})
		})
	},
	post(url, params = {}) {
		return new Promise((resolve, reject) => {
			if(
			url!='https://account1.huashengchongwu.com/api/media/chufangjian_print'
			&&url!='https://account.huashengchongwu.com/api/media/upload_file'
			&&url!='https://account.huashengchongwu.com/api/media/upload_img'
			&&url!='https://account1.huashengchongwu.com/api/media/pos80_print'
			&&url!='https://account1.huashengchongwu.com/api/media/do_print'
			&&url!='https://account1.huashengchongwu.com/api/media/shop_print'
			&&url!='https://account.huashengchongwu.com/api/media/upload_video'
			){
				axios.defaults.headers.shop_id = store.state.shopId;
			}else{
				delete axios.defaults.headers.shop_id
			}
			axios.post(url,params).then(response => {
				let data;
				data = response.data
				resolve(data);
			}).catch(err => {
				reject(err)
			})
		})
	},
	delete(url, params = {}) {
		return new Promise((resolve, reject) => {
			if(
			url!='https://account1.huashengchongwu.com/api/media/chufangjian_print'
			&&url!='https://account.huashengchongwu.com/api/media/upload_file'
			&&url!='https://account.huashengchongwu.com/api/media/upload_img'
			&&url!='https://account1.huashengchongwu.com/api/media/pos80_print'
			){
				axios.defaults.headers.shop_id = store.state.shopId;
			}else{
				delete axios.defaults.headers.shop_id
			}
			axios.delete(url, {
				params
			}).then(response => {
				let data;
				data = response.data
				resolve(data);
			}).catch(err => {
				reject(err)
			})
		})
	},
	get_zt(url, params = {}) {
		return new Promise((resolve, reject) => {
			axios.defaults.headers.shop_id = '';
			axios.get(url, {
				params
			}).then(response => {
				let data;
				data = response.data
				resolve(data);
			}).catch(err => {
				reject(err)
			})
		})
	},
	post_zt(url, params = {}) {
		return new Promise((resolve, reject) => {
			axios.defaults.headers.shop_id = '';
			axios.post(url,params).then(response => {
				let data;
				data = response.data
				resolve(data);
			}).catch(err => {
				reject(err)
			})
		})
	},
}
